import React from "react";
import {Container} from "react-bootstrap";
import {Link} from "react-router-dom";

export function ZhuangziTitle() {
    return <h5 className="author-label"><Link to="/translation/zhuangzi">Zhuāngzǐ (Chuang Tzu)</Link></h5>
}

function Zhuangzi() {
    return (
        <Container>
            <ZhuangziTitle/>
            <ul>
                <li><Link to="/translation/zhuangzi/lord-of-the-center">Lord of the Center</Link></li>
                <li><Link to="/translation/zhuangzi/horses-hooves">Horse's Hooves</Link></li>
            </ul>
            <div>
                <h5>References</h5>
                <ul>
                    <li><a href="https://en.wikipedia.org/wiki/Zhuang_Zhou">Wiki</a></li>
                </ul>
            </div>
        </Container>
)
}

export default Zhuangzi;
